import FormInput, { FormProps } from "../input/FormInput";
import { TextArea } from "./textArea.style";

interface Iprops extends FormProps {
  testid?: string;
  "data-testid"?: string;
}

const TextAreaInput = (props: Iprops) => {
  return (
    <FormInput {...props}>
      <TextArea
        // Callers (e.g. FormField) pass `data-testid`; fall back to the legacy
        // `testid` prop so the textarea always gets the intended test id.
        data-testid={props["data-testid"] ?? props.testid}
        name={props.name}
        onChange={props.onChange}
        onBlur={props.onBlur}
        value={props.value}
        placeholder={props.placeholder}
        disabled={props.disabled}
        maxLength={props.maxLength}
      />
    </FormInput>
  );
};

export default TextAreaInput;
